import classnames from "classnames";
import React, { ReactElement } from "react";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { TransformFunction } from "../../../molecules/Html/Html";
import loadable from "@loadable/component";

import style from "../style.module.scss";

const Html = loadable(() => import("../../../molecules/Html/Html"));

export const YoutubeInfo = (props: {
    title?: string;
    summary?: string;
    showInHeader?: boolean;
    isAudio?: boolean;
    thumbnail?: string;
    contentAlignment?: "left" | "center" | "right";
    contentVerticalAlignment?: "top" | "center" | "bottom";
    showLargePlayButton?: boolean;
}) => {
    const {
        title,
        showInHeader = false,
        summary,
        isAudio = false,
        thumbnail,
        contentAlignment = "center",
        contentVerticalAlignment = "center",
        showLargePlayButton = true,
    } = props;

    /**
     * A transform function for transforming paragraphs in an RTE field into <Typography> components.
     */
    const transformer: TransformFunction = (element: ReactElement<any>) => {
        if (element?.type === "p") {
            return (
                <Typography variant="body" color="white">
                    {element?.props?.children}
                </Typography>
            );
        }
    };

    //slightly lower the vertical alignement of text if the big play button is shown to prevent overlap
    const verticalAlignement =
        contentVerticalAlignment === "center" && showLargePlayButton ? "center_button" : contentVerticalAlignment;

    return title || summary ? (
        <div
            className={classnames(
                isAudio && !thumbnail ? style.player__hide : style.player__content,
                style[`player__content__alignment__horizontal_${contentAlignment}`],
                style[`player__content__alignment__vertical_${verticalAlignement}`],
            )}
        >
            {title && (
                <div className={classnames(style.player__content__title)} data-test-id={"VideoPlayer.Title"}>
                    <Typography variant={showInHeader ? "h2" : "h3"} color="white">
                        {title}
                    </Typography>
                </div>
            )}
            {summary && (
                <div
                    className={classnames(style.player__content__summary)}
                    data-test-id={"VideoPlayer.Summary"}
                    style={{ textAlign: contentAlignment }}
                >
                    {/* Without this transform, the RTE text in summary renders in the player */}
                    {/* So the user sees something similar to '<p>The summary here</p>' */}
                    <Html onTransform={transformer}>{summary}</Html>
                </div>
            )}
        </div>
    ) : null;
};
